/* global trak */
import cookies from 'js-cookie';
import { cookieNames } from '~constants/storage';

const trackingFunctionExists = func =>
  typeof trak !== 'undefined' && typeof trak[func] === 'function';

export const init = (obj = {}) => {
  if (!trackingFunctionExists('init')) {
    return;
  }

  try {
    trak.init(obj);
  } catch (e) {
    // TODO log to sentry?
  }
};

export const getClientSideSuperProperties = () => {
  return {
    'Partner ID': cookies.get(cookieNames.partnerId) || '',
    Partner: cookies.get(cookieNames.partner) || '',
    'User Name': cookies.get(cookieNames.username) || '',
  };
};

export const view = (value, firstLoaded = false) => {
  if (!trackingFunctionExists('view')) {
    return;
  }

  try {
    if (value) {
      trak.view(value, firstLoaded);
    } else {
      trak.view(window.location.pathname, firstLoaded);
    }
  } catch (e) {
    // TODO log to sentry?
  }
};

export default function event(eventName, params) {
  if (!trackingFunctionExists('event')) {
    return;
  }

  try {
    trak.event({
      mp: [
        {
          type: 'track',
          key: eventName,
          params: { ...getClientSideSuperProperties(), ...params },
        },
      ],
    });
  } catch (e) {
    // TODO log to sentry?
  }
}

export const dimension = obj => {
  if (!trackingFunctionExists('dimension')) {
    return;
  }

  try {
    trak.dimension(obj);
  } catch (e) {
    // TODO log to sentry?
  }
};

export const reloadDataAttributeElement = () => {
  if (!trackingFunctionExists('reloadDataAttributeElement')) {
    return;
  }

  try {
    trak.reloadDataAttributeElement();
  } catch (e) {
    // TODO log to sentry?
  }
};
